import React from 'react';
import { observer } from 'mobx-react-lite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  Content, Dialog, Text, Wrapper,
} from './styles';
import Button from '../common/Button';
import useStores from '../../hooks/useStore';

const ErrorDialog = () => {
  const { UIStore } = useStores();
  const { setShowError, errorMessage } = UIStore;

  return (
    <Wrapper>
      <Dialog>
        <Content>
          <FontAwesomeIcon icon="exclamation-circle" color="#c80005" size="3x" />
          <Text>{errorMessage}</Text>
          <Button onClick={() => setShowError(false)}>Close</Button>
        </Content>
      </Dialog>
    </Wrapper>
  );
};

export default observer(ErrorDialog);
